import React from "react";
import { VideoModule } from "../digitalArena/modules/VideoModule";
import { combineProps } from "../helpers/objectHelper";
import { securityHelper } from "../helpers/securityHelper";
import { DailyMotionPlayer } from "./DailyMotionPlayer";
import { VimeoPlayer } from "./VimeoPlayer";
import { YouTubePlayer } from "./YouTubePlayer";

export const GenericPlayer = (props) => {
  const { url } = props;

  if (!url) return null;
  else if (url.includes("vimeo")) return <VimeoPlayer {...props} />;
  else if (url.includes("youtube") || url.includes('youtu.be'))
    return (
      <div className="embeded-frame">
        <YouTubePlayer {...props} />
      </div>
    );
  else if (url.includes("dailymotion") || url.includes("https://dai.ly/"))
    return (
      <div className="embeded-frame">
        <DailyMotionPlayer {...props} />
      </div>
    );
  else if (url.includes("jirango")) {
    return (
      <VideoModule
        {...combineProps([
          {
            settings: { url, downloadable: false },
            clientKey: securityHelper.createGuid(),
          },
        ])}
      />
    );
  } //VIMEO
  else
    return (
      <iframe
        frameBorder="0"
        scrolling="0"
        allowFullScreen
        allow="autoplay; fullscreen"
        style={{ width: "100%", height: "100%", border: "0px" }}
        src={url}
        src={url}
      />
    );
};
